<template>
  <el-dialog
    title="单据详情"
    :visible.sync="visible"
    width="900px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div v-loading="loading">
      <el-descriptions :column="3" border v-if="model">
        <el-descriptions-item label="单据编号">{{ model.number || '' }}</el-descriptions-item>
        <el-descriptions-item label="客户名称">{{ model.organName || '' }}</el-descriptions-item>
        <el-descriptions-item label="单据日期">{{ model.operTimeStr || '' }}</el-descriptions-item>
        <!-- <el-descriptions-item label="仓库">{{ model.depotName || '' }}</el-descriptions-item> -->
        <el-descriptions-item label="联系人">{{ model.contacts || '' }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{ model.telephone || '' }}</el-descriptions-item>
        <el-descriptions-item label="关联单据">{{ model.linkNumber || '' }}</el-descriptions-item>
<!--        <el-descriptions-item label="制单人">{{ model.userName || '' }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="状态">-->
<!--          <el-tag v-if="model.status == '1'" type="success">已审核</el-tag>-->
<!--          <el-tag v-else type="danger">未审核</el-tag>-->
<!--        </el-descriptions-item>-->
      </el-descriptions>
      <el-divider content-position="left">明细</el-divider>
      <div style="overflow-x: auto;">
        <el-table :data="dataSource" border style="margin-top: 20px; width: 2500px;">
          <el-table-column prop="depotName" label="仓库名称" width="120"></el-table-column>
          <el-table-column prop="barCode" label="商品条码" width="150"></el-table-column>
          <el-table-column prop="name" label="商品名称" width="200"></el-table-column>
          <el-table-column prop="standard" label="规格" width="100"></el-table-column>
          <el-table-column prop="model" label="型号" width="100"></el-table-column>
          <el-table-column prop="color" label="颜色" width="80"></el-table-column>
          <el-table-column prop="stock" label="库存" width="80"></el-table-column>
          <el-table-column prop="locationCode" label="库位码" width="100"></el-table-column>
          <el-table-column prop="unit" label="单位" width="80"></el-table-column>
          <el-table-column prop="snList" label="序列号" width="120"></el-table-column>
          <el-table-column prop="batchNumber" label="批号" width="120"></el-table-column>
          <el-table-column prop="engineNumber" label="发动机号" width="120"></el-table-column>
          <el-table-column prop="expirationDate" label="有效期" width="120"></el-table-column>
          <el-table-column prop="sku" label="多属性" width="120"></el-table-column>
          <el-table-column prop="operNumber" label="数量" width="100"></el-table-column>
          <el-table-column prop="floatingRatio" label="浮动比例" width="100"></el-table-column>
          <el-table-column prop="unitPrice" label="单价（不含税）" width="120">
            <template slot-scope="scope">
              {{ scope.row.unitPrice ? scope.row.unitPrice.toLocaleString() : '0' }}
            </template>
          </el-table-column>
          <el-table-column prop="taxUnitPrice" label="单价（含税）" width="120">
            <template slot-scope="scope">
              {{ scope.row.taxUnitPrice ? scope.row.taxUnitPrice.toLocaleString() : '0' }}
            </template>
          </el-table-column>
          <el-table-column prop="allPrice" label="金额" width="120">
            <template slot-scope="scope">
              {{ scope.row.allPrice ? scope.row.allPrice.toLocaleString() : '0' }}
            </template>
          </el-table-column>
          <el-table-column prop="taxRate" label="税率" width="80"></el-table-column>
          <el-table-column prop="taxMoney" label="税额" width="100">
            <template slot-scope="scope">
              {{ scope.row.taxMoney ? scope.row.taxMoney.toLocaleString() : '0' }}
            </template>
          </el-table-column>
          <el-table-column prop="taxLastMoney" label="价税合计" width="100">
            <template slot-scope="scope">
              {{ scope.row.taxLastMoney ? scope.row.taxLastMoney.toLocaleString() : '0' }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="120"></el-table-column>
        </el-table>
      </div>
      <el-divider content-position="left" v-if="model"></el-divider>
      <el-descriptions :column="4" border v-if="model">
        <el-descriptions-item label="优惠率">{{ model.discount ? model.discount + '%' : '0%' }}</el-descriptions-item>
        <el-descriptions-item label="收款优惠">{{ model.discountMoney ? model.discountMoney.toLocaleString() : '0' }}</el-descriptions-item>
        <el-descriptions-item label="优惠后金额">{{ model.discountLastMoney ? model.discountLastMoney.toLocaleString() : '0' }}</el-descriptions-item>
        <el-descriptions-item label="其它费用">{{ model.otherMoney ? model.otherMoney.toLocaleString() : '0' }}</el-descriptions-item>
        <el-descriptions-item label="结算账户">{{ model.accountName || '' }}</el-descriptions-item>
        <el-descriptions-item label="本次收款">{{ model.changeAmount ? model.changeAmount.toLocaleString() : '0' }}</el-descriptions-item>
        <el-descriptions-item label="本次欠款">{{ model.debt ? model.debt.toLocaleString() : '0' }}</el-descriptions-item>
        <el-descriptions-item label="销售人员">{{ model.salesManStr || '' }}</el-descriptions-item>
        <el-descriptions-item label="领料人">{{ model.repairmanStr || '' }}</el-descriptions-item>
        <el-descriptions-item label="合同代码">{{ model.contractCode || '' }}</el-descriptions-item>
        <el-descriptions-item label="欠款天数">{{ model.debtDays || '' }}</el-descriptions-item>
        <el-descriptions-item label="预计还款时间">{{ model.expectedRepaymentDateStr || '' }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { vdsGetSaleOutDetail } from '@/api/invoice'

export default {
  name: 'VdsBillDetail',
  data() {
    return {
      visible: false,
      loading: false,
      token: '',
      model: null,
      dataSource: []
    }
  },
  methods: {
    show(record, token) {
      this.token = token
      this.visible = true
      const newModel = { ...record }
      Object.keys(newModel).forEach(key => {
        const value = newModel[key]
        if (value === null || value === undefined) {
          newModel[key] = ''
        } else if (typeof value === 'object' && Object.keys(value).length === 0) {
          newModel[key] = ''
        }
      })
      this.model = newModel
      this.loadData(record.id)
    },
    loadData(headerId) {
      this.loading = true
      const params = {
        token: this.token,
        headerId: headerId,
        mpList: '自定义1,自定义2,自定义3',
        linkType: 'basic',
        isReadOnly: '1'
      }
      vdsGetSaleOutDetail(params).then(res => {
        if (res.code == 0 && res.data && res.data.code == 200 && res.data.data) {
          let rows = res.data.data.rows || []
          rows = rows.map(row => {
            const newRow = { ...row }
            Object.keys(newRow).forEach(key => {
              const value = newRow[key]
              if (value === null || value === undefined) {
                newRow[key] = ''
              } else if (typeof value === 'object' && Object.keys(value).length === 0) {
                newRow[key] = ''
              }
            })
            return newRow
          })
          this.dataSource = rows
        }
      }).catch(() => {
      }).finally(() => {
        this.loading = false
      })
    },
    handleCancel() {
      this.visible = false
      this.model = null
      this.dataSource = []
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
